import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsUpLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13.04.16H.16v12.88l3.36-3.376l6.16 6.176l6.16-6.16l-6.16-6.16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsUpLeft
